import React from "react";
import styles from "./FullProfile.module.css";

export default function ImpactMetrics({ data }) {
  return (
    <div className={styles.profileData}>
      <h3>
        Impact & <span>metrics</span>
      </h3>
      <div>
        {data &&
          data.about &&
          data.about.split("\n").map((line, idx) => (
            <React.Fragment key={idx}>
              {line}
              <br />
            </React.Fragment>
          ))}
      </div>
    </div>
  );
}
